import { router } from "@inertiajs/react";
import { RefreshCw, TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

/** A failed read with a retry that reloads only the props that failed. */
export function LoadError({ error, only }: { error: string; only: string[] }) {
	const { t } = useTranslation("routing-mode");

	return (
		<Alert variant="destructive">
			<TriangleAlert className="size-4" />
			<AlertTitle>{t("failed.title")}</AlertTitle>
			<AlertDescription className="flex flex-col items-start gap-3">
				<span>{error}</span>
				<Button
					variant="outline"
					size="sm"
					onClick={() => router.reload({ only })}
				>
					<RefreshCw className="size-4" />
					{t("failed.retry")}
				</Button>
			</AlertDescription>
		</Alert>
	);
}
